module.exports = __webpack_public_path__ + "img/noveltwo.cd4ecb00.png";